import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import RmvendorquotationDashboard from '../RmvendorquotationDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setRmvendorquotationDashboardRmvendorquotationList } from 'store/slice/PharmaSlice';
import { useSelector } from 'react-redux';

export default function RmvendorquotationPage() {
    const dispatch = useDispatch();
    const {rmvendorquotationList} = useSelector((state)=>state.pharmaslice);
    const {rawdemandObj} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);

    useEffect(() => {
        dispatch(openDrawer(false));
        dispatch(setRmvendorquotationDashboardRmvendorquotationList(
            rmvendorquotationList.filter(rmvendorquotationObj => rmvendorquotationList.rawdemandid===rawdemandObj.id)
        ))

    },[]);

    return (
        < RmvendorquotationDashboard />
    )

}